import { jsxs as f, jsx as r } from "react/jsx-runtime";
import { c as g, e as I } from "../../vendor-Blw3V4C-.js";
import { useState as l, useEffect as O } from "react";
import { AriaLive as $ } from "../AriaLive/index.js";
import { getButtonStyles as E } from "../BaseButton/index.js";
import { BaseIcon as S } from "../BaseIcon/index.js";
import { TooltipTrigger as _, Tooltip as u } from "../Tooltip/index.js";
import '../../assets/index10.css';const j = "_copyButton_930vx_1", k = {
  copyButton: j
}, P = ({
  onCopy: d,
  onError: m,
  content: n,
  size: y = "md",
  isDisabled: s,
  m: h,
  mt: v,
  mr: x,
  mb: B,
  ml: b
}) => {
  const C = g(
    E({
      size: y,
      m: h,
      mt: v,
      mr: x,
      mb: B,
      ml: b,
      variant: "ghost"
    }),
    k.copyButton
  ), [i, t] = l(!1), [o, c] = l(), T = async () => {
    if (!(typeof o < "u" || s))
      try {
        t(!0), await navigator.clipboard.writeText(n), d?.();
        const e = setTimeout(() => {
          c(void 0), t(!1);
        }, 2500);
        c(e);
      } catch (e) {
        e instanceof DOMException && m?.(e), c(void 0), t(!1);
      }
  };
  O(() => () => {
    clearTimeout(o);
  }, [o]);
  function a() {
    o || t(!0);
  }
  function p() {
    o || t(!1);
  }
  return /* @__PURE__ */ f(_, { isOpen: i, children: [
    /* @__PURE__ */ f(
      I,
      {
        "aria-label": `Copy ${n} to clipboard`,
        onHoverStart: a,
        onHoverEnd: p,
        onFocus: a,
        onBlur: p,
        className: C,
        isDisabled: s,
        onPress: () => {
          T();
        },
        children: [
          /* @__PURE__ */ r(S, { icon: o ? "checkmark" : "copy" }),
          /* @__PURE__ */ r($, { children: o ? "Copy successful" : "Ready to copy" })
        ]
      }
    ),
    o && /* @__PURE__ */ r(u, { children: "Copied" }),
    i && !o && /* @__PURE__ */ r(u, { children: "Copy to clipboard" })
  ] });
};
export {
  P as CopyButton
};
//# sourceMappingURL=index.js.map
